import Vue from 'vue'
import App from './App.vue'

import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import VueClipboard from 'vue-clipboard2';

// for google analytics
import VueGtag from "vue-gtag";

Vue.config.productionTip = false
Vue.use(VueClipboard)

// for google analytics
Vue.use(VueGtag, {
  config: { id: "UA-172942023-1" }
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')
